(function () {
  const playVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const prevSlide = swiper.slides[swiper.previousIndex];
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      const videoActive = activeSlide.querySelector(".slideshow-slide__video");
      if (videoActive) {
        videoActive.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }

    if (prevSlide && prevSlide !== activeSlide) {
      const videoPrev = prevSlide.querySelector(".slideshow-slide__video");
      if (videoPrev) videoPrev.pause();
    }
  };

  const stopVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      const videoActive = activeSlide.querySelector(".slideshow-slide__video");
      if (videoActive) videoActive.pause();
    }
  };

  const initAutoplayObserver = (section, sliderEl) => {
    if (!section || !section?.classList.contains("slideshow-section")) return;
    if (!sliderEl || !sliderEl.swiper) return;

    const hasAutoplay = sliderEl.getAttribute("data-autoplay") === "true";

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (hasAutoplay) sliderEl.swiper.autoplay.resume();
          playVideo(sliderEl.swiper);
        } else {
          if (hasAutoplay) sliderEl.swiper.autoplay.pause();
          stopVideo(sliderEl.swiper);
        }
      });
    });

    sectionObserver.observe(section);
  };

  const initSlideshow = (section) => {
    if (!section || !section?.classList.contains("slideshow-section")) return;

    const sliderEl = section.querySelector(".js-slideshow-swiper");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();

    const animationType = sliderEl.dataset?.animationType || "slide";
    const paginationEl = section.querySelector(".slider-pagination");
    const nextBtn = section.querySelector(".slider-nav-button--next");
    const prevBtn = section.querySelector(".slider-nav-button--prev");
    const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
    const hasSliderAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
    const pauseAutoplayOnHover =
      sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);
    const hasParallax = sliderEl.getAttribute("data-parallax") === "true";

    new Swiper(sliderEl, {
      loop: sliderLoop,
      slidesPerView: 1,
      spaceBetween: 12,
      speed: animationType === "creative" ? 1000 : 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      effect: animationType,
      creativeEffect:
        animationType === "creative"
          ? {
              prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }
          : {},
      resistanceRatio: animationType === "creative" ? 0 : 0.85,
      parallax: hasParallax,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: hasSliderAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseAutoplayOnHover,
          }
        : false,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          if (paginationEl) {
            paginationEl.style.setProperty("--slider-progress", 1 - progress);
          }
        },
        slideChangeTransitionStart() {
          if (animationType === "creative") {
            this.allowSlideNext = false;
            this.allowSlidePrev = false;
            this.allowTouchMove = false;

            const prevSlide = this.slides[this.previousIndex];
            const prevContent = prevSlide?.querySelector(
              ".slideshow-slide__content"
            );
            if (prevContent) {
              prevContent.style.transition = "opacity 0.3s ease";
              prevContent.style.opacity = "0";
            }

            playVideo(this);
          }
        },
        slideChangeTransitionEnd() {
          if (animationType === "creative") {
            this.allowSlideNext = true;
            this.allowSlidePrev = true;
            this.allowTouchMove = true;

            const prevSlide = this.slides[this.previousIndex];
            const prevContent = prevSlide?.querySelector(
              ".slideshow-slide__content"
            );
            if (prevContent) {
              prevContent.removeAttribute("style");
            }
          }
        },
      },
    });

    initAutoplayObserver(section, sliderEl);
  };

  initSlideshow(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlideshow(event.target);
  });
})();
